import { render } from "./chooseProcessToCopyModal.vue?vue&type=template&id=64590740&scoped=true&ts=true"
import script from "./chooseProcessToCopyModal.vue?vue&type=script&lang=ts"
export * from "./chooseProcessToCopyModal.vue?vue&type=script&lang=ts"

import "./chooseProcessToCopyModal.vue?vue&type=style&index=0&id=64590740&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64590740"]])

export default __exports__